import EdModal from "@frameworks/web/components/generic/edModal";
import React, { useEffect } from "react";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import di from "@frameworks/web/components/features/LoginFlow/di/servicelocator";
import MainDI from "@di";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
const LoginHOC = (props) => {
    const device = DeviceContext();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [title, setTitle] = React.useState(props === null || props === void 0 ? void 0 : props.title);
    const [parentClass, setParentClass] = React.useState(props === null || props === void 0 ? void 0 : props.parentClass);
    const [show, setShow] = React.useState(true);
    // useBackListener(() => di.login.flushLoginError());
    const onCloseGoBackFunction = () => {
        di.login.flushLoginError();
        di.login.flushLoginData();
        if (!(props === null || props === void 0 ? void 0 : props.skipRedirectNavigation)) {
            navigate("/");
        }
        else {
            (props === null || props === void 0 ? void 0 : props.parentCallBack) !== null &&
                (props === null || props === void 0 ? void 0 : props.parentCallBack) !== undefined &&
                typeof (props === null || props === void 0 ? void 0 : props.parentCallBack) === "function" &&
                (props === null || props === void 0 ? void 0 : props.parentCallBack());
            setShow(false);
            di.login.updateResetLoginState(true);
        }
    };
    useEffect(() => {
        if (props.title) {
            setTitle(props.title);
        }
    }, [props.title]);
    React.useEffect(() => {
        if ((device === null || device === void 0 ? void 0 : device.isDesktop) === false) {
            dispatch(MainDI.footer.updateShowMob_Menu(false));
            MainDI.header.RemoveHeaderData(false);
        }
    }, []);
    return (React.createElement("div", { className: `loginsection ${parentClass ? parentClass : props.parentClass}` }, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(EdModal, { show: show, setShow: setShow, modalTitle: "modalLogin", title: title ? title : props.title, size: "modal-md modal-dialog-centered", showFooter: false, DisableOutsideClickClose: true, onCloseGoBack: true, onCloseGoBackFunction: onCloseGoBackFunction, modalbodyClass: props.modalbodyClass }, React.createElement(props.component, Object.assign({}, props, { setTitle: setTitle, setParentClass: setParentClass })))) : (React.createElement("div", { className: "pb-5" },
        React.createElement(props.component, Object.assign({}, props))))));
};
export default LoginHOC;
